// @ts-check
import React, { useState } from 'react'
import { Label, Error } from '..'
import { isEmpty, isNil } from 'ramda'
import styles from './style.css'
import { validateUTF8StringLength } from '../../utils/validateUTFStringLength'
import classNames from 'classnames'
import { HidePassword, ShowPassword } from '../Icons/Icons'

/**
 * @param {{
 * id?: string,
 * placeholder?: string,
 * value: string,
 * label: string,
 * onChange?: {(event: React.ChangeEvent): void},
 * onKeyDown?: {(event: React.KeyboardEvent): void},
 * onBlur?: {(event: React.FocusEvent): void},
 * onFocus?: {(event: React.FocusEvent): void},
 * onInvalid?: {(event: React.FormEvent): void},
 * error: string | React.Component,
 * disabled?: boolean,
 * required?: boolean,
 * valid: boolean,
 * name: string,
 * maxLength?: number,
 * minLength?: number,
 * pattern?: string,
 * showLabelAsPlaceholder?: boolean,
 * info?: string,
 * className?: string,
 * classNameError?: string,
 * children?: React.ReactNode }} props
 */
const InputPassword = ({
  id,
  label,
  error,
  showLabelAsPlaceholder,
  valid,
  info,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  onFocus,
  onInvalid,
  disabled,
  required,
  maxLength,
  minLength,
  pattern,
  onKeyDown,
  className,
  classNameError,
  children
}) => {
  const [showPassword, setShowPassword] = useState(false)
  /**
   * @type {string}
   */
  const htmlFor = id ?? label
  const onChangeHandler = (event) => {
    const { target: { value } } = event
    if (maxLength) {
      if (validateUTF8StringLength(value, maxLength)) {
        onChange(event)
      }
    } else {
      onChange(event)
    }
  }

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev)
  }

  return (
    <div className={styles.field}>
      {!showLabelAsPlaceholder && (
        <Label htmlFor={htmlFor} value={label} valid={valid} info={info} />
      )}
      <div className={styles.inputWrapper}>

        <input
          className={classNames(styles.input, className, {
            [styles.inputInvalid]: !isEmpty(error) && !isNil(error)
          })}
          id={htmlFor}
          name={name}
          type={showPassword ? 'text' : 'password'}
          placeholder={showLabelAsPlaceholder ? label : placeholder}
          value={value}
          onChange={onChangeHandler}
          onBlur={onBlur}
          onFocus={onFocus}
          onInvalid={onInvalid}
          disabled={disabled}
          required={required}
          maxLength={maxLength}
          minLength={minLength}
          pattern={pattern}
          autoComplete='new-password'
          onKeyDown={onKeyDown}
        />
        <div className={styles.lockIcon} onClick={toggleShowPassword}>
          {showPassword ? <ShowPassword /> : <HidePassword />}
        </div>
      </div>
      {children}
      <Error value={error} className={classNameError} />
    </div>
  )
}

export { InputPassword }
